
import { defineComponent, PropType } from "vue";
import Subtitle from "~/components/Common/Subtitle.vue";
import GoogleMapView from "~/components/Common/GoogleMapView.vue";
import CompanyName from "~/components/UserAccounts/CompanyName.vue";
import UserSnsButtons from "~/components/UserAccounts/UserSnsButtons.vue";
import UserAccountModel from "~/models/UserAccountModel";

export default defineComponent({
  name: "UserInfo",
  components: {
    UserSnsButtons,
    CompanyName,
    GoogleMapView,
    Subtitle
  },
  props: {
    userAccount: {
      type: Object as PropType<UserAccountModel>,
      required: true
    },
    mediumId: {
      type: Number,
      default: 0
    }
  }
});
